module.exports = __webpack_public_path__ + "static/img/6.0453690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6.jpg
// module id = +0l3
// module chunks = 26